import { render } from "./AdminChat.vue?vue&type=template&id=63c5a540&scoped=true&ts=true"
import script from "./AdminChat.vue?vue&type=script&lang=ts"
export * from "./AdminChat.vue?vue&type=script&lang=ts"

import "./AdminChat.vue?vue&type=style&index=0&id=63c5a540&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63c5a540"]])

export default __exports__